import type DensityOptionState from './schema/DensityOptionState';
import { createStore } from 'owa-satcheljs';

const defaultExport: () => DensityOptionState = createStore<DensityOptionState>(
    'densityOptionState',
    {
        densityModeSelected: null,
        useSingleLineMessageStyle: null,
    }
);
export default defaultExport;
